(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-embedded-product-cards"] && !Shopify.designMode) return;
  try {
    function parsePCTokens(rawHtmlString, contextData) {
    // Matches [[shop:KEY]] and captures "KEY" in a group
    const tokenRegex = /\[\[pc:([\w-]+)\]\]/g;

    return rawHtmlString.replace(tokenRegex, (match, key) => {
      // Check if the specific property exists in your data payload
      if (contextData.hasOwnProperty(key)) {
        return contextData[key];
      }

      // Return the original token if data is missing, or return '' to clear it
      return match;
    });
  }

  document.addEventListener('DOMContentLoaded', ()=> {
    const $article = document.querySelector('article.article');
    if (!$article) { return }

    const $pcTemplates = document.querySelectorAll('template[pc-template]');
    const cardMap = new Map();
    $pcTemplates.forEach($template => {
      const productId = $template.dataset.productId;
      cardMap.set(productId, $template.innerHTML);
    });

    const pcToken = /\[\[pc:([\w-]+)\]\]/g;
    $article.innerHTML = $article.innerHTML.replace(pcToken, (match, productId) => {
      if (cardMap.has(productId)) {
        return cardMap.get(productId);
      }

      return match;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
